module.exports = __webpack_public_path__ + "dist/assets/browser-edge.34f9b4aeb4793a4e7fb9e0a4d7a3006e.png";